import 'select2';
import 'select2/dist/css/select2.css';  // optional if you have css loader


window.inputSelect = new(function() {
    this.initWideSelector = function(){
        $('[data-barba-namespace]:last-of-type').find('.custom-select').each(function(index){
            var $this = $(this);
            var allowClear = $this.data('empty') ? true : false;
            var noSearch = $this.data('nosearch') ? -1 : 0;
  
            $(this).select2({
                //dropdownParent: $this.parent(),
                theme:"big-drop",
                lenisPrevent:1,
                data:{

                },
                minimumResultsForSearch:Infinity,
                allowClear:allowClear
            });
            $(this).on('select2:open',()=>{
                $('.select2-dropdown').attr('data-lenis-prevent',true)
            })
            $(this).parent().find('.select2-selection__rendered').attr('aria-label','search item')
        });
    }
    this.initSmallSelector = function(){
        $('[data-barba-namespace]:last-of-type').find('.custom-select-mini').each(function(index){
            var $this = $(this);
            var allowClear = $this.data('clear') ? true : false;
            var noSearch = $this.data('nosearch') ? Infinity : 0;
            var layout = $this.data('layout') ? $this.data('layout') : ''
            $(this).select2({
                dropdownParent: $this.parent(),
                theme:"mini-"+layout,
                minimumResultsForSearch: noSearch,
                allowClear:allowClear
            });
            $(this).parent().find('.select2-selection__rendered').attr('aria-label','search item')

        });
    }
})
